export default function generateChartBar(chart, data){
  chart.updateOptions({ stroke: { show: false }})
  chart.appendSeries({ name: 'Incasso', data: data.net_amounts})
  chart.appendSeries({ name: 'Incasso senza Betterplazed', data: data.net_amounts_without_bp})
}